export default "__VITE_ASSET__D0H78IEY__"